/**
 * Per-feature cache policy overrides. Defaults documented in
 * docs/architecture/data-layer-spec.md §3.1; overrides in §3.2.
 *
 * Hooks consume these via `cachePolicies.<feature>.<action>.staleTime`.
 * Anything not listed here uses the global QueryClient defaults.
 */

const SECOND = 1000;
const MINUTE = 60 * SECOND;

export const globalDefaults = {
  staleTime: 30 * SECOND,
  gcTime: 5 * MINUTE,
} as const;

export const cachePolicies = {
  roteiros: {
    list: { staleTime: 30 * SECOND, gcTime: 5 * MINUTE },
    detail: { staleTime: 60 * SECOND, gcTime: 10 * MINUTE },
  },
  pacientes: {
    list: { staleTime: 30 * SECOND, gcTime: 5 * MINUTE },
  },
  consultas: {
    list: { staleTime: 30 * SECOND, gcTime: 5 * MINUTE },
  },
  ranking: {
    list: { staleTime: 60 * SECOND, gcTime: 5 * MINUTE },
  },
  funil: {
    metrics: { staleTime: 15 * SECOND, gcTime: 5 * MINUTE },
  },
  instagram: {
    accountStats: { staleTime: 5 * MINUTE, gcTime: 30 * MINUTE },
  },
  personas: {
    list: { staleTime: 5 * MINUTE, gcTime: 30 * MINUTE },
  },
  decodificar: {
    list: { staleTime: 30 * SECOND, gcTime: 5 * MINUTE },
  },
  diagnostico: {
    snapshot: { staleTime: 60 * SECOND, gcTime: 5 * MINUTE },
  },
  videos: {
    list: { staleTime: 30 * SECOND, gcTime: 5 * MINUTE },
  },
  auth: {
    session: { staleTime: Infinity, gcTime: Infinity },
  },
  byok: {
    list: { staleTime: 30 * SECOND, gcTime: 5 * MINUTE },
  },
  admin: {
    users: { staleTime: 30 * SECOND, gcTime: 5 * MINUTE },
  },
  uso: {
    summary: { staleTime: 60 * SECOND, gcTime: 5 * MINUTE },
  },
} as const;
